import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class SpcialistService {

  constructor(private httpRes: HttpRequestService) { }

  AddSpecialist(data){

    return this.httpRes.postRequest("Specialist/addspecialist",data)
  }
  getSpecialistById(id){
    return this.httpRes.GetRequest("Specialist/getSpecialistId/" + id)
  }
  getSpecialistByUserId(UserId){
    return this.httpRes.GetRequest("Specialist/SpecialistByUserId/" + UserId)
  }
  UpdateSpecialist(data){

    return this.httpRes.postRequest("Specialist/UpdateSpecialist",data)
  }
}
